module.exports = __webpack_public_path__ + "img/new_63.70656678.jpg";